import { useDispatch } from "react-redux";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import { useNavigate } from "react-router-dom";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageCancelationPolicySection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsCancelationPolicy, {
      state: { optionData },
    });
  };

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Cancelation Policy</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Cancelation Policy Type</p>
              <p className="text-secondary capitalize">
                {optionData?.cancelationPolicy?.type === "standard"
                  ? "Standard"
                  : optionData?.cancelationPolicy?.type === "custom"
                  ? "Custom"
                  : optionData?.cancelationPolicy?.type === "all_sales_final"
                  ? "All Sales Final"
                  : "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Is The Weather Condition Bad?</p>
              <p className="text-secondary capitalize">
                {optionData?.cancelationPolicy?.description ?? "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Cancel If The Weather Condition Bad?</p>
              <p className="text-secondary capitalize">
                {optionData?.cancelationPolicy?.cancelIfBadWeather === true
                  ? "Yes"
                  : "No"}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">
                Cancel If Insufficient Travelers
              </p>
              <p className="text-secondary capitalize">
                {optionData?.cancelationPolicy
                  ?.cancelIfInsufficientTravelers === true
                  ? "Yes"
                  : "No"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div>
            <div className="space-y-2">
              <p className="text-sm font-bold">Refund Eligibility</p>
              <div className="text-secondary capitalize">
                {Array.isArray(
                  optionData?.cancelationPolicy?.refundEligibility
                ) && optionData.cancelationPolicy.refundEligibility.length > 0
                  ? optionData.cancelationPolicy.refundEligibility.map(
                      (
                        {
                          dayRangeMin,
                          dayRangeMax,
                          percentageRefundable,
                        }: {
                          dayRangeMin: number;
                          dayRangeMax?: number;
                          percentageRefundable: number;
                        },
                        idx: number
                      ) => {
                        const dayRangeText =
                          typeof dayRangeMax === "number"
                            ? `${dayRangeMin}-${dayRangeMax} day${
                                dayRangeMax !== 1 ? "s" : ""
                              }`
                            : `${dayRangeMin}+ day${
                                dayRangeMin !== 1 ? "s" : ""
                              }`;
                        return (
                          <div key={idx} className="flex gap-2 mb-2">
                            <span>
                              {dayRangeText}: {percentageRefundable}% will be
                              refunded
                            </span>
                          </div>
                        );
                      }
                    )
                  : "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
